import type { PromptStarter } from './types';

export const defaultPromptStarters: PromptStarter[] = [
  { label: 'prompt_starter.differentiate.label', promptText: 'prompt_starter.differentiate.prompt', labelText: 'Differentiate' },
  { label: 'prompt_starter.rewrite.label', promptText: 'prompt_starter.rewrite.prompt', labelText: 'Rewrite' },
  { label: 'prompt_starter.questions.label', promptText: 'prompt_starter.questions.prompt', labelText: 'Questions' },
  { label: 'prompt_starter.resources.label', promptText: 'prompt_starter.resources.prompt', labelText: 'Resources' },
];

export const ERROR_TOKEN = '[[[ERROR]]]';

export const X_MODEL_USED_HEADER = 'X-Model-Used';

export const INITIAL_MESSAGE_INTL_ID = 'monitoring-table.initial-generation';
export const IMAGE_EDITED_INTL_ID = 'image-generator.image-edited';

export const FALLBACK_CHARACTER_CONTEXT_LIMIT = '450000';
